import Img1 from 'assets/innvolight/oct-solutions/img1.png'
import Img2 from 'assets/innvolight/oct-solutions/img2.png'
import Img3 from 'assets/innvolight/oct-solutions/img3.png'
import Img4 from 'assets/innvolight/oct-solutions/img4.png'
import Img5 from 'assets/innvolight/oct-solutions/img5.png'

export default function OctSolutions() {
  return (
    <div className="relative h-auto bg-center bg-slate-100">
      <div className="relative z-10 max-w-[1440px] w-full mx-auto h-full py-20  px-4  md:px-10 lg:px-16 2xl:px-0">
        <div className="flex flex-col w-full gap-10">
          <div className="flex justify-start w-full">
            <h3 className="text-2xl font-bold text-left text-black sm:text-2xl md:text-3xl gsap-opacity-trans-appear">
              <span className="text-orange">First-in-class</span> OCT Solution
            </h3>
          </div>
          <div className="flex flex-col w-full max-w-5xl gap-10 mx-auto">
            <div className="flex flex-col items-center justify-center gap-2 gsap-opacity-trans-appear">
              <div className="w-full max-w-4xl">
                <img
                  src={Img1}
                  className="object-contain w-full h-full"
                  alt=""
                />
              </div>
              <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                <span className="text-orange">Pre & Post PCI Image</span>{' '}
                Comparison
              </h4>
            </div>
            <div className="grid gap-10 sm:grid-cols-2 gsap-stagger-bounce-parent">
              <div className="gsap-stagger-bounce">
                <div className="flex flex-col items-center justify-center gap-2 text-center">
                  <img
                    src={Img2}
                    className="w-auto h-[280px] md:h-[320px] lg:h-[420px] p-2 border-2"
                    alt=""
                  />
                  <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                    <span className="text-orange">Continuous</span> Calibration
                  </h4>
                </div>
              </div>
              <div className="gsap-stagger-bounce">
                <div className="flex flex-col items-center justify-center gap-2 text-center">
                  <img
                    src={Img3}
                    className="w-auto h-[280px] md:h-[320px] lg:h-[420px]"
                    alt=""
                  />
                  <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                    3D <span className="text-orange">View</span>
                  </h4>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center gap-2 gsap-opacity-trans-appear">
              <div className="w-full max-w-4xl p-2 border-2">
                <img
                  src={Img4}
                  className="object-contain w-full h-full"
                  alt=""
                />
              </div>
              <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                Auto Assessment of Stent Apposition
              </h4>
            </div>
            <div className="flex flex-col items-center justify-center gap-2 gsap-opacity-trans-appear">
              <div className="w-full max-w-4xl p-2 border-2">
                <img
                  src={Img5}
                  className="object-contain w-full h-full"
                  alt=""
                />
              </div>
              <h4 className="text-sm font-bold text-center sm:text-lg md:text-base lg:text-2xl">
                Auto Assessment of Stent Expansion
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
